import { atom } from "recoil";

export const DetailNewsState = atom({
  key: "DetailNewsState",
  default: undefined,
});
